import { IPaymentRequisitionState } from '@/store/payment-requisition';
import { IPaymentRequisitionGetters } from './getters.types';
import {
  IPaymentRequisition,
  PaymentRequisition,
  IUser,
  User,
  IPaymentRequisitionData,
  IUserData,
  IPaymentRequisitionComment,
  PaymentRequisitionComment
} from '@/models';
import { Transition } from '@/models/transition';

export const getters: IPaymentRequisitionGetters = {
  getPaymentRequisitionCount(state: IPaymentRequisitionState): number {
    return state.count;
  },

  getPaymentRequisitions(
    state: IPaymentRequisitionState
  ): IPaymentRequisition[] {
    return state.paymentRequisitions.map(
      (data: IPaymentRequisitionData) => new PaymentRequisition(data)
    );
  },

  getPaymentRequisitionById: (state: IPaymentRequisitionState) => (
    id: number
  ): IPaymentRequisition | undefined => {
    const data = state.paymentRequisitions.find(
      paymentRequisition => paymentRequisition.id === id
    );
    if (!data) {
      return undefined;
    }

    return new PaymentRequisition(data);
  },

  getPaymentRequisitionApprovers: (
    state: IPaymentRequisitionState
  ): IUser[] => {
    return state.approvers.map((data: IUserData) => new User(data));
  },

  getPaymentRequisitionAPSpecialists: (
    state: IPaymentRequisitionState
  ): IUser[] => {
    return state.apSpecialists.map((data: IUserData) => new User(data));
  },

  getPaymentRequisitionActivities: (
    state: IPaymentRequisitionState
  ): Transition[] => {
    return state.activities;
  },

  getPaymentRequisitionComments: (
    state: IPaymentRequisitionState
  ): IPaymentRequisitionComment[] => {
    return state.comments.map(data => new PaymentRequisitionComment(data));
  },

  getPaymentRequisitionCommentById: (state: IPaymentRequisitionState) => (
    id: number
  ): IPaymentRequisitionComment | undefined => {
    const data = state.comments.find(
      paymentRequisition => paymentRequisition.id === id
    );
    if (!data) {
      return undefined;
    }

    return new PaymentRequisitionComment(data);
  },

  getLastCreatedPaymentRequisitionId: (
    state: IPaymentRequisitionState
  ): null | number => {
    return state.lastCreatedPaymentRequisitionId;
  },

  getLastCreatedPaymentRequisitionCommentId: (
    state: IPaymentRequisitionState
  ): null | number => {
    return state.lastCreatedPaymentRequisitionCommentId;
  },

  getPaymentRequisitionMentionableUsers(
    state: IPaymentRequisitionState
  ): IUser[] {
    return state.mentionableUsers.map(data => new User(data));
  }
};
